import { createModel } from "@rematch/core";
import { RootModel } from "app/store";
import {
  ListRequestParams,
  mergeListParams,
  mergeListParamsWithPagination,
  OrderByType,
} from "widgets/table/useTableUtils";
import { api } from "api";
import { ExamTypeVm } from "api/generated/lumen";
import { mapToGetAllQuery } from "utils";

interface ExamTypeListState {
  listParams: ListRequestParams;
  list: ExamTypeVm[];
}

const initialState: ExamTypeListState = {
  listParams: {
    pageSize: 10,
    order: [
      {
        orderBy: "name",
        orderByType: OrderByType.Ascending,
      },
    ],
  },
  list: [],
};

export const examTypeList = createModel<RootModel>()({
  state: initialState,
  reducers: {
    resetListParams(state) {
      state.listParams = {
        ...initialState.listParams,
        order: initialState.listParams.order,
      };
    },
    setList(
      state,
      {
        data,
        listParams,
      }: { data: ExamTypeVm[]; listParams: ListRequestParams }
    ) {
      state.list = data;
      state.listParams = listParams;
    },
    reset: () => initialState,
  },
  effects: (dispatch) => {
    const { examTypeList } = dispatch;

    return {
      async fetchList(params: ListRequestParams = {}, state): Promise<void> {
        const mergedParams = mergeListParams(
          state.examTypeList.listParams,
          params
        );

        const data = await api.lumen.examTypes.apiExamTypesGetAllPost({
          getAllExamTypesQuery: mapToGetAllQuery(mergedParams),
        });

        const { items, ...pagination } = data;

        dispatch(
          examTypeList.setList({
            data: items || [],
            listParams: mergeListParamsWithPagination(mergedParams, pagination),
          })
        );
      },

      async delete(id: string): Promise<void> {
        return api.lumen.examTypes.apiExamTypesIdDelete({ id });
      },
    };
  },
});
